interface Props {
  readonly isAnimated: boolean;
}

const BackgroundWaves = ({ isAnimated }: Props): JSX.Element => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 4096 666.92"
    enableBackground="new 0 0 4096 666.92"
    xmlSpace="preserve"
    className={isAnimated ? 'animated' : ''}
  >
    <g id="background">
      <path
        id="waves"
        fill="#29ABE2"
        stroke="#010101"
        strokeWidth="2"
        strokeMiterlimit="10"
        d="M4175.17,579.36V452.01
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79s-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79s-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79
		c-41.29,0-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		c-41.29,0-41.29-26.79-82.58-26.79s-41.29,26.79-82.58,26.79c-41.29,0-41.29-26.79-82.58-26.79c-41.29,0-41.29,26.79-82.58,26.79
		v100.56H4175.17z"
      />
      <path
        id="transition"
        fill="#29ABE2"
        d="M4424.11,543.46c-271.01,77.43-825.07,117.69-1138.23,105.85
		c-313.16-11.84-456.16-50.11-613.51-39.27s-494.61,40.89-816.8,41.26s-234.87-28.24-545.03-41.26s-252.94,21.95-406.51,41.27
		S445,670.25,0,597.02s973.28-50.08,973.28-50.08L4424.11,543.46"
      />
    </g>
  </svg>
);

export default BackgroundWaves;
